import { GETPRODUCTS } from "redux/constants/Product";

const getProductsAction = (payload) => ({
  type: GETPRODUCTS,
  payload,
});

export { getProductsAction };
